// extracted by mini-css-extract-plugin
export default {"profileNavLinks":"NavList_profileNavLinks__Qm+-G","active":"NavList_active__oi1RW"};